import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';
import {
    // AutoComplete,
    Flex,
    Skeleton,
    Input,
    List
    // Tabs
} from "antd";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

// import { DestinationSelector } from "./DestinationSelector";
// import { EntitiesP } from './Entities';
// import { SourcesDataProvider } from "./SourcesDataProvider";

import { getDataverseInstances } from '../../api/template/template';
import { PATHS } from "../../constants/PATHS";
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import {
    // clearDataverseState,
    setInstance,
    setOperationIdentifier
} from '../../store/slices/dataverseSlice';
import { ErrorView } from '../Error/ErrorView';

export const DataverseInstances = () => {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const selectedInstance = useAppSelector(state => state.dataverse.selectedInstance);
    // const selectedEntity = useAppSelector(state => state.dataverse.selectedEntity);
   
    const { data, isError, error, isLoading, refetch } = useQuery({
        queryKey: ['dataverse instances', activeAccount?.username],
        queryFn: async () => {
            const request = {
                scopes: ["https://globaldisco.crm.dynamics.com/.default"],
                account: activeAccount ?? undefined, // Ensure account is undefined if null
                prompt: "consent"
            };

            let instanceToken;
            try {
                const tokenResponse = await instance.acquireTokenSilent(request);
                instanceToken = tokenResponse.accessToken;
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    const tokenResponse = await instance.acquireTokenPopup(request);
                    instanceToken = tokenResponse.accessToken;
                } else {
                    // console.error("Token acquisition failed:", error);
                }
            }

            if (!instanceToken) {
                throw new Error("No access token");
            }
            
            const res = await getDataverseInstances({ "X-Ms-Access-Token": instanceToken });
            
            return res.data;
        },
        enabled: !!activeAccount // Only run the query if we have an active account
    });

    useEffect(() => {
        if (data?.data?.operationIdentifier) {
            dispatch(setOperationIdentifier(data.data.operationIdentifier));
        }
    }, [data]);
    
    if (isLoading) return <InstancesPlaceholder />;

    if (isError) return (
        <Flex align="center" justify="center" style={{ width: "100%", height: "100%" }}>
            <ErrorView message="Failed to load Instances" error={error} showDetails />
            <button onClick={() => refetch()} style={{ marginTop: 20 }}>Retry</button>
        </Flex>
    );

    return (
        <Flex gap={16}>
            <Flex vertical>
                {<Instances dvInstaces={data?.data?.instances} />}
                {/* {selectedInstance && <Outlet />} */}
            </Flex>
            {/* {<Instances dvInstaces={data?.data?.instances} />} */}
            {selectedInstance && <Outlet />}
        </Flex>
    );
};

export const Instances = ({ dvInstaces = [] }: { dvInstaces: any[] }) => {
    const urlParams = useParams();
    const navigate = useNavigate();
    const [searchString, setSearchString] = useState("");
    const selectedInstance = useAppSelector(state => state.dataverse.selectedInstance);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const selectedInstance = dvInstaces.find(env => env.environmentId === urlParams.instanceIdentifier);
        if (urlParams.instanceIdentifier && selectedInstance) {
            dispatch(setInstance(selectedInstance.url));
        }
    }, [urlParams.instanceIdentifier, dvInstaces]);

    const items = dvInstaces.map((env) => ({
        label: env.friendlyName || env.url,
        value: env.url,
        envId: env.environmentId,
        // children: <Flex style={{ width: "100%" }}><EntitiesP /></Flex>,
    }));

    return (
        <Flex align="flex-start" >
            <Flex vertical align="center" justify="center" gap={20} style={{ width: "100%", maxWidth: 200 }}>
                <Input.Search
                    value={searchString}
                    onChange={(e) => setSearchString(e.target.value)}
                    placeholder="Search Instances"
                    variant="outlined"
                />
                <List
                    style={{ width: "100%", height: "100%" }}
                    dataSource={items.filter(item => item.label.toLowerCase().includes(searchString.toLowerCase()))}
                    renderItem={(item) => (
                        <List.Item
                            key={item.value}
                            onClick={() => {
                                navigate(`${PATHS.DATAVERSE}/${urlParams.destinationIdentifier}/${item.envId}`);
                                dispatch(setInstance(item.value));
                            }}
                            style={{ cursor: "pointer", padding: "8px 16px" }}
                        >
                            <Flex justify="space-between" align="center" style={{ width: "100%" }}>
                                <span>{item.label}</span>
                                {selectedInstance === item.value && <span>Selected</span>}
                            </Flex>
                        </List.Item>
                    )}
                />
            </Flex>           
            {/* <AutoComplete
                // tabPosition="left"
                popupMatchSelectWidth
                allowClear
                // value={items.find((item) => item.value === selectedInstance)}
                value={selectedInstance}
                options={items}
                placeholder="Select a Dataverse Instance"
                filterOption={(inputValue, option) => {
                    const regex = new RegExp(inputValue, "i");
                    return regex.test(option?.value ?? "");
                }}
                onSelect={(value, option) => {
                    navigate(`${PATHS.DATAVERSE}/${urlParams.destinationIdentifier}/${option.envId}`);
                    dispatch(setInstance(value));
                }}
                onClear={() => {
                    navigate(`${PATHS.DATAVERSE}/${urlParams.destinationIdentifier}`);
                    dispatch(clearDataverseState());
                }}
                style={{ width: "150px" }}
            /> */}
        </Flex>
    );
}

const InstancesPlaceholder = () => {
    return (
        <Flex align="flex-start" justify="flex-stretch" style={{ width: "100%", height: "100%" }} gap={20}>
            <Flex vertical align="center" justify="center" gap={20}>
                {Array.from({ length: 10 }).map((p, i) => <Skeleton.Button key={i} active style={{ width: 250 }}/>)}
            </Flex>
            <Flex vertical align="center" justify="center" gap={20}>
                {Array.from({ length: 10 }).map((p, i) => <Skeleton.Button key={i} active style={{ width: 250 }}/>)}
            </Flex>
            <Flex vertical align="center" justify="center" gap={20}>
                {Array.from({ length: 10 }).map((p, i) => <Skeleton.Button key={i} active style={{ width: 600 }}/>)}
            </Flex>
        </Flex>
    );
}

